<template>
    <div>
        <DesignPriceHeader
            :design-price-header="designPriceHeader"
            :return-url="returnUrl"
        ></DesignPriceHeader>
        <DesignPriceView
            :hash="hash"
            :design-price-product="designPriceProduct"
            :design-price-package="designPricePackage"
            :design-price-sticker="designPriceSticker"
        ></DesignPriceView>
    </div>
</template>

<script setup lang="ts">
import {
    DesignPriceHeaderType,
    DesignPricePackageType,
    DesignPriceProductType,
    DesignPriceStickerType,
} from '@/types/DesignPriceType';
import DesignPriceHeader from '~/components/design-price/DesignPriceHeader.vue';
import DesignPriceView from '~/components/design-price/DesignPriceView.vue';

const props = defineProps<{
    blok: {
        type: object;
        required: true;
    };
    nextBlock?: {
        type: object;
        required: false;
        default: null;
    };
}>();

const state = reactive<{
    returnUrl: string;
}>({
    returnUrl: '/',
});

const hash = computed(() => {
    return useRoute().hash || '';
});

const { previousRoute } = usePreviousRoute();

const designPriceHeader = computed<DesignPriceHeaderType>(() => {
    return {
        headerFull: props.blok.header_full,
        headerShort: props.blok.header_short,
    };
});

const designPriceProduct = computed<DesignPriceProductType>(() => {
    return {
        productTypeQuestion: props.blok.product_type_question,
        packageImage: props.blok.package_image,
        stickersAndLabelsImage: props.blok.stickers_and_labels_image,
    };
});

const designPricePackage = computed<DesignPricePackageType>(() => {
    return {
        packageQuestion: props.blok.package_question,
        gussetBagImage: props.blok.gusset_bag_image,
        flatBottomBagImage: props.blok.flat_bottom_bag_image,
        tinCanImage: props.blok.tin_can_image,
        paperTubeImage: props.blok.paper_tube_image,
        standUpPouchImage: props.blok.stand_up_pouch_image,
        flatPouchImage: props.blok.flat_pouch_image,
        quantityQuestion: props.blok.quantity_question,
        designOptionsQuestion: props.blok.design_options_question,
        designOptionsHelp: props.blok.design_options_help,
        roastarDesignLabImage: props.blok.roastar_design_lab_image,
        uploadYourOwnImage: props.blok.upload_your_own_image,
    };
});

const designPriceSticker = computed<DesignPriceStickerType>(() => {
    return {
        stickerQuestion: props.blok.sticker_question,
        customDieCutStickersImage: props.blok.custom_die_cut_stickers_image,
        circleOvalStickerImage: props.blok.circle_oval_sticker_image,
        squareRectangleStickerImage: props.blok.square_rectangle_sticker_image,
        coffeeBagLabelsImage: props.blok.coffee_bag_labels_image,
        beverageLabelImage: props.blok.beverage_label_image,
    };
});

onMounted(() => {
    if (previousRoute.value) {
        state.returnUrl = previousRoute.value.path;
    }
});

const { returnUrl } = toRefs(state);
</script>
